import React from 'react';
import { Link } from 'react-router-dom';
import GroupBreathworkImage from '../imgs/group_online.jpg';
import IndividualInstruction from '../imgs/1on1_instruction.jpg';
import WimHofImage from '../imgs/wim_hof.jpg';
import CommunityImage from '../imgs/community.jpg';
import SoundBathImage from '../imgs/sound_bath.jpg';
import TravelImage from '../imgs/travel.jpg';

const servicesData = [
  {
    name: 'Group Breathwork Classes - Online',
    image: GroupBreathworkImage,
    link: '/group-breathwork',
  },
  {
    name: 'Individual 1:1 Instruction',
    image: IndividualInstruction,
    link: '/individual-instruction',
  },
  {
    name: 'Wim Hof Fundamentals Workshop',
    image: WimHofImage,
    link: '/wim-hof-workshop',
  },
  {
    name: 'Community Breathwork',
    image: CommunityImage,
    link: '/community-breathwork',
  },
  {
    name: 'Cacao Ceremony and Sound Bath',
    image: SoundBathImage,
    link: '/cacao-and-sound-bath',
  },
  {
    name: 'Travel Retreats',
    image: TravelImage,
    link: '/travel-retreats',
  },
];

const Services: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan px-8 py-28">
      <h1 className="text-5xl font-bold text-darkgreentext text-center mb-12">
        Our Services
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {servicesData.map((service) => (
          <Link to={service.link} key={service.name} className="relative group">
            <img
              src={service.image}
              alt={service.name}
              className="w-full h-72 object-cover rounded-lg shadow-lg"
            />
            <div className="absolute inset-0 bg-black bg-opacity-30 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h2 className="text-white text-2xl font-bold">{service.name}</h2>
            </div>
          </Link>
        ))}
      </div>
      <div className="max-w-4xl mx-auto px-8 pt-16 text-center">
        <p className="text-3xl font-bold text-darkgreentext leading-relaxed">
          Don’t see classes that fit your schedule? We are growing and trying to evolve. Let us know what you’d like to see!
        </p>
      </div>
      <div className="flex justify-center pb-8">
        <Link to="/contact" className="mt-4 px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition">
          Contact Us Here!
        </Link>
      </div>
    </div>
  );
};

export default Services;
